import type {PermissionType} from '@hconnect/apiclient'
import React from 'react'
import {Outlet} from 'react-router'

import {PermissionDeniedFallback} from '../../common/components/PermissionDeniedFallback'
import {useAnyPermission, usePermission} from '../../permissions'
import {RouteName} from '../routes'

interface PermissionGuardedRouteProps {
  requiredPermissions: [type: PermissionType, ...types: PermissionType[]]
  isRouteAllowed?: boolean
}

export const PermissionGuardedRoute: React.FC<PermissionGuardedRouteProps> = ({
  requiredPermissions,
  isRouteAllowed = true
}) => {
  const isAccessGranted = usePermission(...requiredPermissions)

  if (!(isAccessGranted && isRouteAllowed)) {
    return <PermissionDeniedFallback dataTestId={`page_${RouteName.NOT_AUTHORIZED}`} />
  }
  return <Outlet />
}

export const AnyPermissionGuardedRoute: React.FC<PermissionGuardedRouteProps> = ({
  requiredPermissions,
  isRouteAllowed = true
}) => {
  const isAccessGranted = useAnyPermission(...requiredPermissions)

  if (!(isAccessGranted && isRouteAllowed)) {
    return <PermissionDeniedFallback dataTestId={`page_${RouteName.NOT_AUTHORIZED}`} />
  }
  return <Outlet />
}
